export type GeniusBulkItem = {
  imageAssetKey: string;
  soundAssetKey: string;
  label?: string;
};

const KEY_RE = /^[a-zA-Z0-9_-]+$/;

export function sanitizeGeniusAssetKey(raw: string): string {
  return raw.trim().replace(/[^a-zA-Z0-9_-]/g, '');
}

/**
 * One item per line. Formats:
 * - `001` → image and sound `001`
 * - `001,002` or `001;002` → image `001`, sound `002`
 * - `001,001,Pikachu` → optional label (third field)
 */
export function parseGeniusBulkLines(raw: string): GeniusBulkItem[] {
  const out: GeniusBulkItem[] = [];
  const seen = new Set<string>();

  for (const line of raw.split(/\r?\n/)) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith('#')) continue;

    const parts = trimmed.split(/[,;\t|]/).map((p) => p.trim());
    const imageAssetKey = sanitizeGeniusAssetKey(parts[0] ?? '');
    if (!imageAssetKey || !KEY_RE.test(imageAssetKey)) continue;

    const soundRaw = parts[1] ? sanitizeGeniusAssetKey(parts[1]) : imageAssetKey;
    const soundAssetKey = soundRaw && KEY_RE.test(soundRaw) ? soundRaw : imageAssetKey;
    const label = parts.slice(2).join(',').trim() || undefined;

    if (seen.has(imageAssetKey)) continue;
    seen.add(imageAssetKey);

    out.push({ imageAssetKey, soundAssetKey, label });
  }

  return out;
}
